import { api } from '@services';

import { IPaginationResult } from '@models/Equipment.model';
import ProductSpecGroupModel, {
  IProductSpecGroup,
  IProductSpecGroupApiModel,
} from '@models/ProductSpecGroup.model';
import { filterEmptyParams } from '@utils/filterEmptyParams';

interface IPagination2 {
  q?: string;
  page?: number;
  limit?: number | string;
}

interface IRequest {
  params: IPagination2;
  productId: string;
}

export const MAX_BIGINT = BigInt('9123372036854776000');

const getProductSpecGroups = async ({
  params,
  productId,
}: IRequest): Promise<IPaginationResult<IProductSpecGroup>> => {
  const entries = Object.entries(params).filter(filterEmptyParams);
  const urlSearch = new URLSearchParams(entries);
  const { data } = await api.get<IPaginationResult<IProductSpecGroupApiModel>>(
    `/products/specification/${productId}`,
    {
      params: urlSearch,
    },
  );

  return ProductSpecGroupModel.fromArrayPaginatedApiModel(data);
};

export { getProductSpecGroups };
